import "./input_image_new.scss";
import IconUpload from "../../assets/icons/icon_upload.svg"
import IconCloseImage from "../../assets/icons/icon_close_image.svg"
import IconPreviewImage from "../../assets/icons/icon_preview_image.svg"
import { useEffect, useRef, useState } from "react";
import Modal from 'react-modal';
import CustomModal from "../custom_modal";
import Button from "../button";

const InputImageNew = (props) => {
    // const fileInputRef = props.ref;

    // const handleClick = () => {
    //     fileInputRef.current.click();
    // };

    return (
        <>
            <div className={`form-group ${props.label ? "m-1" : ""}`}>
                {
                    props.label ? <label className="input-image-label" htmlFor={props.id}>{props.label}</label> : null
                }
                <input
                    id="inputBulk"
                    accept=".zip,.svg,.png,.jpg,.jpeg"
                    type="file"
                    // ref={props.ref}
                    multiple={true}
                    onChange={props.onChange}
                    style={{ display: 'none' }} />

                <div className="custom-file-input" onClick={() => document.getElementById('inputBulk').click()}>
                    <img src={IconUpload} className="icon-upload" />
                    <div className="text-upload">Browse files</div>
                </div>
            </div>

        </>
    )
}
export default InputImageNew